export default __webpack_public_path__ + "static/media/icons8-iot-sensor-100.e8cb9949.svg";